import { StackProps, VStack } from '@adc/parallax-component-library';
import React from 'react';

type ProgressBarProps = {
  progress: number; // Progress value between 0 and 100
  color?: StackProps['backgroundColor']; // Design system color token, defaults to primary blue
  testId?: string; // Optional test ID for testing
};

export function ProgressBar({
  progress,
  color = '$abbott.lightBlue.default',
  testId,
}: ProgressBarProps): React.JSX.Element {
  return (
    <VStack
      height={12}
      backgroundColor="$neutral.20"
      borderRadius={6}
      testID={testId}
    >
      <VStack
        width={`${progress}%`}
        backgroundColor={color}
        height={12}
        borderRadius={6}
      />
    </VStack>
  );
}
